import { render, staticRenderFns } from "./BrandList.vue?vue&type=template&id=757d40a2&scoped=true&"
import script from "./BrandList.vue?vue&type=script&lang=ts&"
export * from "./BrandList.vue?vue&type=script&lang=ts&"
import style0 from "./BrandList.vue?vue&type=style&index=0&id=757d40a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757d40a2",
  null
  
)

export default component.exports